import {useEffect} from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

const config = {
    current_lang: "en",
    autorun: true,
    autoclear_cookies: true,
    gui_options: {
        consent_modal: {
            layout: "cloud", // box/cloud/bar
            position: "bottom center", // bottom/middle/top + left/right/center
            transition: "slide", // zoom/slide
            swap_buttons: false, // enable to invert buttons
        },
        settings_modal: {
            layout: "box", // box/bar
            // position: 'left',           // left/right
            transition: "zoom", // zoom/slide
        },
    },
    languages: {
        en: {
            consent_modal: {
                title: "We use cookies!",
                description:
                    'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                primary_btn: {
                    text: "Accept all",
                    role: "accept_all", // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: "Reject all",
                    role: "accept_necessary", // 'settings' or 'accept_necessary'
                },
            },
            settings_modal: {
                title: "Cookie preferences",
                save_settings_btn: "Save settings",
                accept_all_btn: "Accept all",
                reject_all_btn: "Reject all",
                close_btn_label: "Close",
                cookie_table_headers: [
                    {col1: "Name"},
                    {col2: "Domain"},
                    {col3: "Expiration"},
                    {col4: "Description"},
                ],
                blocks: [
                    {
                        title: "Cookie usage 📢",
                        description:
                            'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.',
                    },
                    {
                        title: "Strictly necessary cookies",
                        description:
                            "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
                        toggle: {
                            value: "necessary",
                            enabled: true,
                            readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
                        },
                    },
                    {
                        title: "Performance and Analytics cookies",
                        description:
                            "These cookies allow the website to remember the choices you have made in the past",
                        toggle: {
                            value: "analytics", // your cookie category
                            enabled: false,
                            readonly: false,
                        },
                        cookie_table: [
                            // list of all expected cookies
                            {
                                col1: "^_ga", // match all cookies starting with "_ga"
                                col2: "google.com",
                                col3: "2 years",
                                col4: "description ...",
                                is_regex: true,
                            },
                            {
                                col1: "_gid",
                                col2: "google.com",
                                col3: "1 day",
                                col4: "description ...",
                            },
                        ],
                    },
                    {
                        title: "Advertisement and Targeting cookies",
                        description:
                            "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you",
                        toggle: {
                            value: "targeting",
                            enabled: false,
                            readonly: false,
                        },
                    },
                    {
                        title: "More information",
                        description:
                            'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
                    },
                ],
            },
        },
    },
};


export default function XCookieConsent() {
    useEffect(() => {
        /**
         * All config. options available here:
         * https://cookieconsent.orestbida.com/reference/configuration-reference.html
         */
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: 'bar',
                    position: 'bottom left',
                    flipButtons: false,
                    equalWeightButtons: true
                },
                preferencesModal: {
                    layout: 'box',
                    // position: 'left right',
                    flipButtons: false,
                    equalWeightButtons: true
                }
            },
            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {}
            },

            language: {
                default: 'en',
                translations: {
                    en: {
                        consentModal: {
                            title: 'Predvoľby súkromia',
                            description: 'Cookies používame na zlepšenie vašej návštevy tejto webovej stránky, analýzu jej výkonnosti a zhromažďovanie údajov o jej používaní. Na tento účel môžeme použiť nástroje a služby tretích strán a zhromaždené údaje sa môžu preniesť k partnerom v EÚ, USA alebo iných krajinách. Kliknutím na „Prijať všetko“ vyjadrujete svoj súhlas s týmto spracovaním.',
                            acceptAllBtn: 'Prijať všetko',
                            acceptNecessaryBtn: 'Prijať len nevyhnutné',
                            // showPreferencesBtn: 'Podrobnosti'
                        },
                        preferencesModal: {
                            title: 'Manage cookie preferences',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            savePreferencesBtn: 'Accept current selection',
                            closeIconLabel: 'Close modal',
                            sections: [
                                {
                                    title: 'Somebody said ... cookies?',
                                    description: 'I want one!'
                                },
                                {
                                    title: 'Strictly Necessary cookies',
                                    description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

                                    //this field will generate a toggle linked to the 'necessary' category
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Performance and Analytics',
                                    description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                    linkedCategory: 'analytics'
                                },
                                {
                                    title: 'More information',
                                    description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
                                }
                            ]
                        }
                    }
                }
            },
            onConsent: function ({cookie}) {
                // eslint-disable-next-line no-undef
                gtag('consent', 'update', {
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            },
        });
    }, []);

    return null;
}